import Vue from 'vue';
export default Vue.extend({
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        hideOverlay: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        hideHeader: {
            type: Boolean,
            default: false,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'md',
            validator: (v) => ['sm', 'md', 'lg', 'xs', 'xl', '2xl', '3xl'].includes(v),
        },
        persistent: {
            type: Boolean,
            default: false,
        },
        wrapperClass: {
            type: String,
            default: '',
        },
        toast: {
            type: Boolean,
            default: false,
        },
        bodyClass: {
            type: String,
            default: '',
        },
        target: {
            type: String,
            default: 'modal-outlet',
        },
        top: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        titleClass: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        isOpen: false,
    }),
    computed: {
        sizeClass() {
            switch (this.size) {
                case 'sm':
                    return 'sm:max-w-sm';
                case 'lg':
                    return 'sm:max-w-lg';
                case 'xl':
                    return 'sm:max-w-xl';
                case '2xl':
                    return 'sm:max-w-2xl';
                case '3xl':
                    return 'sm:max-w-3xl';
                default:
                case 'md':
                    return 'sm:max-w-md';
            }
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.isOpen = val;
            },
        },
        isOpen: {
            immediate: true,
            handler(val) {
                this.$emit('input', val);
                if (val) {
                    document.body.classList.add('overflow-hidden');
                }
                else {
                    document.body.classList.remove('overflow-hidden');
                }
            },
        },
    },
    created() {
        window.addEventListener('keydown', this.listenKeys);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.listenKeys);
    },
    methods: {
        listenKeys(e) {
            if (this.isOpen && e.keyCode == 27) {
                this.close();
            }
        },
        toggle() {
            if (this.disabled)
                return;
            this.isOpen = !this.isOpen;
            this.$emit('toggle');
        },
        open() {
            this.isOpen = true;
            this.$emit('open');
        },
        close() {
            if (this.disabled)
                return;
            this.isOpen = false;
            this.$emit('close');
            this.$emit('input', false);
        },
        onOverlayClick() {
            if (!this.persistent) {
                this.close();
            }
        },
    },
});
